const configVariableValues = {
  EMAIL_APPOINTMENT_NOTIFICATION: 'email_appointment_notification',
  INACTIVE_SESSION_TIMEOUT: 'app_inactiveSession_timeout',
  MANDATORY_HEALTHCARD_USER: 'mandatory_healthCard_user',
  MANDATORY_NHC_USER: 'mandatory_nhc_user',
  SMS_APPOINTMENT_NOTIFICATION: 'sms_appointment_notification',
  GOOGLE_MAPS: 'google_maps',
  DIRECT_ACCESS_TIMEOUT: 'app_direct_access_timeout',
  PATIENT_REGISTRATION_MODE: 'patient_registration_mode',
  MEDICAL_RECORD_FROM_FILTER_MIN_MONTHS: 'medical_record_from_filter_min_months',
  DEFAULT_PRIVATE_PATIENT_INSURANCES: 'default_private_patient_insurances',
  GOOGLE_FIT_SYNC: 'google_fit_sync',
  CAREPATH: 'carepath',
  PUSH_NOTIFICATION: 'push_notification',
  VITAL_SIGNS: 'vital_signs',
  DOUBLE_FACTOR_AUTH_ACTIVE: 'double_factor_auth_active',
  DOUBLE_FACTOR_AUTH_METHOD: 'double_factor_auth_method',
  CAPTCHA_ENABLED: 'captcha_enabled',
  PROFILE_SYNCHRONIZATION_MODE: 'profile_synchronization_mode',
  ACTIVE_LANGUAGE_LOCALES: 'active_language_locales',
  MAX_ATTACHMENT_SIZE: 'max_attachment_size',
  DEFAULT_APPOINTMENT_SLOT_SEARCH_SCOPE: 'default_appointment_slot_search_scope',
  ALLOW_REQUEST_APPOINTMENT_WITHOUT_IDENTIFICATION: 'allow_request_appointment_without_identification',
  MULTIPLE_INSURANCE_AVAILABLE: 'multiple_insurance_available',
  USER_REGISTRATION_MIN_AGE: 'user_registration_min_age',
  ACTIVE_HOME_ACTIONS: 'active_home_actions'
};

export {
  configVariableValues
};
